<template>
	<div>
		<div class="row">
			<div class="col-md-5 col-12 mt-auto">
				<h3>Target Sales Kecamatan</h3>
				<!-- <h6>Choose 1 Dealer To Use This Feature</h6> -->
			</div>
			<div class="col-md-2 col-6 mt-2 wrapHighlight">
				<Multiselect 
					:options="filterData.dealer.map(x => x.code)"
					:custom-label="opt => filterData.dealer.find(x => x.code == opt).name"
					placeholder="All Dealer"
					:allow-empty="true"
					v-model="filter.kd_dealer"
				/>
			</div>
			<div class="col-md-2 col-3 mt-2 wrapHighlight">
				<Multiselect 
					:options="filterData.kecamatan.map(x => x.kodekecamatan)"
					:custom-label="opt => filterData.kecamatan.find(x => x.kodekecamatan == opt).name"
					placeholder="All Kecamatan"
					:allow-empty="true"
					v-model="filter.kd_kecamatan"
				/>
			</div>
			<div class="col-md-2 col-3 mt-2">
				<div class="block w-100 datepickerSeperator">
					<DatePicker
						class="w-100"
						v-model="selected.date"
						type="monthrange"
						range-separator="-"
						start-placeholder="Start"
						end-placeholder="End"
						style="height:46px">
					</DatePicker>
				</div>

			</div>
			<div class="col-md-1 col-3 mt-2">
				<button class="btn w-100 btn-primary" style="height:46px" @click="loadApi">Search</button>
			</div>
		</div>

		<div class="row mt-1" style="margin-right:-15px">
			<div class="col-md-2">
				<button class="btn border border-secondary rounded w-100 shadow" @click="modal.uploadTarget = true"><i class="fa fa-upload"></i> Upload Target</button>
			</div>
			<div class="offset-md-8 col-md-2 text-right" >
				<button class="btn border border-secondary rounded w-100 shadow" @click="modalData = null;modal.modifyModal = true">+ Add Target</button>
			</div>

		</div>


		<vue-universal-table 
			:api_url="'/api/target/mcd'"
			:filter="filter"
			:update="update"
			:fields='fields'
			:process_data="process_data"
			:buttons="buttons"
			@onDelete="deleteData"
			@onEdit="editData"
		/>

		<UploadTarget 
			v-if="modal.uploadTarget"
			@closeModal="modal.uploadTarget = false"
			@onFinish="loadApi"
		/>

		<ModifyModal
			v-if="modal.modifyModal"
			@closeModal="modal.modifyModal = false"
			@onFinish="loadApi"
			:data="modalData"
			:dealer="filterData.dealer"
			:kecamatan="filterData.kecamatan"
		/>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
const XLSX = require('xlsx')
import moment from 'moment'
import { DatePicker } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

locale.use(lang)


import ModifyModal from './Children/ModalModify.vue'
import UploadTarget from './Children/ModalUpload.vue'

export default {
	components : {
		Multiselect,
		DatePicker,
		UploadTarget,
		ModifyModal
	},
	data () {
		let now = new moment()
		let totalMonth = now.month() + 1

		let month_year = ''
		// console.log(now)
		for(var  i = 1 ; i <= totalMonth ; i++ ) {
			month_year += `${now.year()}-${i}`
			if(i != totalMonth)
				month_year += ','
		}


		return {
			modal : {
				uploadTarget : false,
				modifyModal : false
			},
			modalData : null,
			filter : {
				kd_dealer : null,
				kd_kecamatan : null,
				month_year : month_year
			},
			filterData : {
				dealer : this.$store.getters.getDealer(null , null),
				kecamatan : null
			},
			selected : {
				date : [
					new Date().setMonth(0),
					new Date()
				]
			},
			
			update : 0,
			fields : [{
				title : 'Dealer',
				variable : 'complete_dealer'
			},{
				title : 'Kecamatan',
				variable : 'complete_kecamatan'
			},{
				title : 'Month & Year',
				variable : 'month_year'
			},{
				title : 'Target Unit',
				variable : 'target_unit'
			},{
				title : 'Created By',
				variable : 'created_by'
			},{
				title : 'Created At',
				variable : 'created_at'
			}],
			buttons : [{
				title : 'Edit',
				class : 'btn btn-outline-primary fa fa-edit'
			},{
				title : 'Delete',
				variable : 'uniqueid',
				class : 'btn btn-outline-danger fa fa-times'
			}],
			process_data : `
				for(var i = 0 ; i < data.length ; i++) {
					data[i].complete_dealer = data[i].kd_dealer + ' - ' + data[i].nama_dealer 
					data[i].complete_kecamatan = data[i].kd_kecamatan + ' - ' + data[i].nama_kecamatan
					data[i].month_year = new this.moment().month(parseInt(data[i].month) - 1).year(data[i].year).format('MMM Y')
					data[i].created_at = new this.moment(data[i].created_at).format('DD MMMM Y | HH:mm')
				}
			`
		}
	},
	watch : {
		'selected.date' : function () {
			console.log(this.selected.date)

			let start = new moment(this.selected.date[0])
			let end = new moment(this.selected.date[1])

			let monthDiff = end.diff(start , 'months', true)
			console.log(monthDiff)

			let month_year = ''
			for(var i = 0 ; i < monthDiff ; i++) {
				month_year += `${start.year()}-${start.month() + 1}`
				start = start.add(1 , 'month')
				if(i != monthDiff - 1) {
					month_year += ','
				}
			}
			this.filter.month_year = month_year
		}
	},
	mounted () {
		this.loadKecamatan()
	},
	methods : {
		loadKecamatan () {
			this.$http.get('/api/master/kecamatan')
			.then((resp) => {
				this.filterData.kecamatan = resp.data.data
				
				this.filterData.kecamatan.map(x => x.name = `${x.kodekecamatan} - ${x.nama_kecamatan}`)
			})
			.catch((err) => {
				console.log(err)
			})
		},
		loadApi() {
			this.update++
		},
		editData (data) {
			this.modalData = JSON.parse(data)
			this.modal.modifyModal = true
		},
		deleteData(id) {
			id = id.split('"').join('')
			this.$http.delete('/api/target/mcd/' + id)
			.then((resp) => {
				this.loadApi()
				this.$store.dispatch('triggerAlert' , [false , 'Successfully Delete MCD Target'])
			})
			.catch((err) => {
				console.log(err)
			})
		}
	}
}
</script>

<style scoped>
	.text-red {
		color : red;
	}
	.text-green {
		color : green;
	}

	.btn-primary {
		background-color : #ff9700;
		border-color: #ff9700;
	}
</style>

<style>
	.datepickerSeperator .el-range-separator {
		margin-top : 5px;
		margin-right : 5px;
	}

	.datepickerSeperator .el-input__icon {
		margin-top : 3px;
	}
</style>